import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { MediaPlayIcon } from '@sketchnote/icons';
import classNames from 'classnames';
import * as React from 'react';
import YouTube from 'react-youtube';

import Dialog from '../dialogs';

const { useState } = React;

export interface VideoCardProps {
  className?: string;
  translations: {
    video_thumbnail_label: string;
  };
  thumbnailUrl: string;
  videoId: string;
  onClose?: () => void;
}

export const VideoCard = ({
  className,
  translations,
  thumbnailUrl,
  videoId,
  onClose,
}: VideoCardProps) => {
  const [isVideoOpened, setIsVideoOpened] = useState(false);
  const opts = {
    height: '573',
    width: '1020',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };
  const handleVideoOpen = (open: boolean) => {
    setIsVideoOpened(open);
  };
  return (
    <React.Fragment>
      <div
        className={classNames({
          'flex flex-col items-center text-center justify-center h-182 bg-cover bg-no-repeat rounded px-50':
            true,
          [className || '']: !!className,
        })}
        role="button"
        tabIndex={0}
        onKeyDown={() => null}
        style={{
          backgroundImage: `url(${thumbnailUrl})`,
          boxShadow: 'inset 0 0 0 2000px rgba(19, 23, 32, 0.7)',
        }}
        onClick={handleVideoOpen.bind(this, true)}
      >
        <MediaPlayIcon wrapperClass="text-7xl mb-8" />
        <span className="text-white text-base">{translations.video_thumbnail_label}</span>
      </div>

      <Modal isOpen={isVideoOpened} onClose={handleVideoOpen.bind(this, false)}>
        <ModalContent style={{ maxWidth: '1020px', height: '573px', margin: 'auto' }}>
          <div className="rounded">
            <YouTube
              videoId={videoId}
              opts={{ height: '573', width: '1020', playerVars: { autoplay: 1 } }}
              onPlay={(event) => {
                event.target.playVideo();
              }}
            />
          </div>
        </ModalContent>
      </Modal>
    </React.Fragment>
  );
};
